import { provide, defineComponent, reactive, watch } from 'vue';
import warning from '../_util/warning';
import { withInstall } from '../_util/type';
import { localeDataSymbol } from '../_util/globalSymbol';
export const ANT_MARK = 'internalMark';
const LocaleProvider = defineComponent({
    name: 'ALocaleProvider',
    props: {
        locale: {
            type: Object,
        },
        ANT_MARK__: String,
    },
    setup(props, { slots }) {
        warning(props.ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead');
        const state = reactive({
            antLocale: {
                ...props.locale,
                exist: true,
            },
            ANT_MARK__: ANT_MARK,
        });
        provide(localeDataSymbol, state);
        watch(() => props.locale, () => {
            state.antLocale = {
                ...props.locale,
                exist: true,
            };
        }, { immediate: true });
        return () => {
            return slots.default?.();
        };
    },
});
/* istanbul ignore next */
LocaleProvider.install = function (app) {
    app.component(LocaleProvider.name, LocaleProvider);
    return app;
};
export default withInstall(LocaleProvider);
